import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import AuthProvider from "./components/AuthProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/auth/LoginPage";
import RegisterPage from "./pages/auth/RegisterPage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import ItemListPage from "./pages/items/ItemListPage";
import ItemDetailPage from "./pages/items/ItemDetailPage";
import ItemFormPage from "./pages/items/ItemFormPage";
import SettingsPage from "./pages/settings/SettingsPage";
import CalculatorPage from "./pages/calculator/CalculatorPage";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route
                path="/"
                element={<Navigate to="/dashboard" replace />}
              />
              <Route
                path="/dashboard"
                element={<Layout><DashboardPage /></Layout>}
              />
              <Route
                path="/items"
                element={<Layout><ItemListPage /></Layout>}
              />
              <Route
                path="/items/new"
                element={<Layout><ItemFormPage /></Layout>}
              />
              <Route
                path="/items/:id"
                element={<Layout><ItemDetailPage /></Layout>}
              />
              <Route
                path="/items/:id/edit"
                element={<Layout><ItemFormPage /></Layout>}
              />
              <Route
                path="/calculator"
                element={<Layout><CalculatorPage /></Layout>}
              />
              <Route
                path="/settings"
                element={<Layout><SettingsPage /></Layout>}
              />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
